/**
 * components/controls/StatusFilter.jsx
 */

import { ChevronDown } from "lucide-react";
import {
    useCrudListState,
    useCrudListDispatch,
    ACTIONS,
} from "../../context/CrudContext";

export default function StatusFilter() {
    const dispatch = useCrudListDispatch();
    const state = useCrudListState();

    return (
        <select
            value={state.status}
            onChange={(e) =>
                dispatch({
                    type: ACTIONS.SET_STATUS,
                    payload: e.target.value,
                })
            }
            className="w-full sm:w-auto bg-white hover:text-inherit border border-gray-200 rounded-md ps-4 pe-8 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-accent"
        >
            <option value="">All Status</option>
            <option value="publish">Published</option>
            <option value="draft">Draft</option>
            <option value="trash">Trash</option>
        </select>
    );
}
